import React from 'react';
import PropTypes from 'prop-types';
import CloseWindowButton from '../../../../../../atomic/buttons/closeWindow/CloseWindowButton';
import style from './EntryModuleWrapper.module.css';
import MarketOrderModule from '../modules/MarketOrderModule';
import LimitOrderModule from '../modules/LimitOrderModule';
import CandleBreakModule from '../modules/CandleBreakModule';

export default function EntryModuleWrapper({
  type,
  index,
  removeTactic,
  stateProps,
}) {
  let component;
  let setter;
  switch (type) {
    case 'Market Order':
      component = (
        <MarketOrderModule
          state={stateProps.marketOrder}
          top={stateProps.top}
        />
      );
      setter = stateProps.marketOrder[3];
      break;
    case 'Limit Order':
      component = (
        <LimitOrderModule state={stateProps.limitOrder} top={stateProps.top} />
      );
      setter = stateProps.limitOrder[3];
      break;
    case 'Candle Break':
      component = (
        <CandleBreakModule
          state={stateProps.candleBreak}
          top={stateProps.top}
        />
      );
      setter = stateProps.candleBreak[3];
      break;
    default:
      break;
  }
  return (
    <div className={style.wrapper}>
      {component}
      <CloseWindowButton
        width={10}
        color="red"
        stroke={3}
        display="block"
        handleClick={() => {
          removeTactic(index);
          setter(false);
        }}
      />
    </div>
  );
}

EntryModuleWrapper.propTypes = {
  type: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  removeTactic: PropTypes.func.isRequired,
  stateProps: PropTypes.object.isRequired,
};
